class ShiftFront {
  constructor({
    shiftId = null,
    name = null,
    description = null,
    startTime = null,
    endTime = null,
    isStartTimeFixed = null,
    complexEquation = null,
    isnew = false,
  }) {
    this.shiftId = shiftId;
    this.name = name;
    this.description = description;
    this.startTime = new Date(startTime);
    this.endTime = new Date(endTime);
    this.isStartTimeFixed = isStartTimeFixed;
    this.complexEquation = complexEquation;
    this.isnew = isnew;
  }
}

class ShiftBack {
  constructor({
    shiftId = null,
    companyId = null,
    name = null,
    description = null,
    startTime = null,
    endTime = null,
    isStartTimeFixed = null,
    complexEquation = null,
  }) {
    this.shiftId = shiftId;
    this.name = name;
    this.companyId = companyId;
    this.description = description;
    this.startTime = startTime;
    this.endTime = endTime;
    this.isStartTimeFixed = isStartTimeFixed;
    this.complexEquation = complexEquation;
  }
}

export { ShiftBack, ShiftFront };
